import React from "react";
import Dashboard from "../../components/lotto5/Dashboard";
import Lotto5Nav from "../../components/lotto5/Lotto5Nav";
import MainDrawingWrapper from "../../components/lotto5/MainDrawingWrapper";

const Lotto5Dashboard = () => {
    return (
        <div className="main-w">
            <div className="main">
                <div className="w-1200">
                    <div className="wrapper-new-lotto5 lotto5">
                        <MainDrawingWrapper>
                            <Lotto5Nav/>
                            <Dashboard/>
                        </MainDrawingWrapper>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Lotto5Dashboard;